module.exports = __webpack_public_path__ + "static/media/custom-eight-2.74649b79.jpg";